/* eslint-disable @typescript-eslint/no-explicit-any*/

import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { VITE_APPLICATION_NAME } from '~/config/env';

import Loading from '@portal/components/Loading/Loading';

interface PanelContentProps {
  pageTitle?: string;
  pageDescription?: string;
  children?: React.ReactNode;
  className?: string;
}

const PanelContent = ({
  children,
  pageTitle,
  className,
}: PanelContentProps) => {
  const isLoading = useSelector(
    (state: reducers.rootReducer) => state.loading.amount
  );

  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  return (
    <>
      <Helmet>
        <title>{`${pageTitle} - ${VITE_APPLICATION_NAME}`}</title>
      </Helmet>

      {isLoading > 0 && <Loading testId="home_Loading" />}

      <div className="panel-content">
        <div className={`panel-content__inner ${className}`}>{children}</div>
      </div>
    </>
  );
};

export default PanelContent;
